import React from "react";
import { HiX, HiExclamationCircle, HiCheckCircle } from "react-icons/hi";

const MessageBox = ({ error, success, message, onClose }) => {
  // Don't render anything if there is no message to display
  if (!message) return null;

  const isError = error;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`relative flex w-full items-start gap-3 rounded-lg border p-4 text-sm transition-all duration-300 animate-in fade-in zoom-in-95 ${isError
          ? "border-red-200 bg-red-50 text-red-800"
          : "border-emerald-200 bg-emerald-50 text-emerald-800"
        }`}
    >
      {/* Icon */}
      <div className="mt-0.5 shrink-0">
        {isError ? (
          <HiExclamationCircle className="h-5 w-5 text-red-500" aria-hidden="true" />
        ) : (
          <HiCheckCircle className="h-5 w-5 text-emerald-500" aria-hidden="true" />
        )}
      </div>

      {/* Message Content */}
      <div className="flex-1 font-medium leading-snug">
        {message}
      </div>

      {/* Dismiss Button */}
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Dismiss message"
          className={`-mx-1.5 -my-1.5 inline-flex rounded-md p-1.5 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${isError
              ? "text-red-500 hover:bg-red-100 focus:ring-red-600 focus:ring-offset-red-50"
              : "text-emerald-500 hover:bg-emerald-100 focus:ring-emerald-600 focus:ring-offset-emerald-50"
            }`}
        >
          <HiX className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default MessageBox;